import { PROGRESS } from 'config/config';
import { getContainerHeight } from 'helpers/commonHelper';
import React, { createRef, PureComponent, RefObject } from 'react';

import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import withContext from '../../hoc/withContext';
import withTextContext from '../../hoc/withTextContext';

interface IProps extends IAccordionWrapper, IContext, RouteComponentProps<{ paymentId: string }> {
  paymentMethods: IMethod[];
}

class PayPo extends PureComponent<IProps> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  payPoPaymentMethodId = '';

  async componentDidMount() {
    const { paymentMethods, setHeight } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
    this.payPoPaymentMethodId = paymentMethods[0].id;
  }

  componentDidUpdate() {
    if (this.shouldRefreshState()) {
      const { setHeight } = this.props;
      setHeight(getContainerHeight(this.containerRef.current));
    }
  }

  shouldRefreshState() {
    const { paymentMethodId, progress } = this.props;

    return this.payPoPaymentMethodId === paymentMethodId && progress < PROGRESS.SELECT_PAYPO_METHOD;
  }

  render() {
    return <div className="paypo__container" ref={this.containerRef} />;
  }
}

export default withContext(withTextContext(withRouter(PayPo)));
